import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../Component/Comman/PageTitle';
import { marketCardData } from '../../Component/Data/MarketData/MarketData';
import MarketTabing from '../../Component/Market/MarketTabing';
import TopSmallCard from '../../Component/Market/TopSmallCard';
import { fetchSymbols } from '../../Redux/Actions/dataActions';

function Market({ symbols, fetchSymbols, loading }) {
    useEffect(() => {
        if ((!symbols || symbols.length === 0) && !loading) {
            fetchSymbols();
        }
    }, [symbols, fetchSymbols, loading]);

    // Get top symbols from API or use default data
    const topSymbols = symbols && symbols.length > 0 
        ? symbols.slice(0, 4).map(sym => ({
            header: sym.symbol || sym.name || '',
            coin: sym.symbol || sym.name || '',
            color: (sym.changePercent || sym.priceChangePercent || 0) >= 0,
            rate: sym.price || sym.currentPrice || 0,
            doller: `$${sym.price || sym.currentPrice || 0}`,
            percentag: `${(sym.changePercent || sym.priceChangePercent || 0) >= 0 ? '+' : ''}${(sym.changePercent || sym.priceChangePercent || 0).toFixed(2)}%`,
        }))
        : marketCardData;

    return (
        <>
            <div className="body-header border-bottom d-flex py-3 mb-3">
                <PageTitle pagetitle='Market' downloadbutton='Download' reportbutton='Generate Report' />
            </div>
            <div className="container-xxl">
                <div className="row g-3 row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-4 mb-3">
                    {
                        topSymbols.map((d, i) => {
                            return (
                                <TopSmallCard
                                    header={d.header}
                                    coin={d.coin}
                                    color={d.color}
                                    rate={d.rate}
                                    doller={d.doller}
                                    percentag={d.percentag}
                                    key={'s' + i}
                                />
                            )
                        })
                    }

                </div>
                <MarketTabing />
            </div>

        </>
    )
}

const mapStateToProps = (state) => ({
    symbols: state.data?.symbols || [],
});

export default connect(mapStateToProps, { fetchSymbols })(Market);